var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1666 10.3333C19.4679 10.3333 21.3333 8.46789 21.3333 6.16672C21.3333 3.86554 19.4679 2 17.1666 2C14.8654 2 13 3.86554 13 6.16672C13 8.46789 14.8654 10.3333 17.1666 10.3333ZM17.1721 11.9995C17.1704 11.9997 17.1688 11.9999 17.1671 11.9999C13.9513 11.9999 11.3338 9.38313 11.3338 6.16658C11.3338 5.28233 11.5372 4.44646 11.8914 3.69481C11.7079 3.67741 11.5221 3.66658 11.3338 3.66658C8.11221 3.66658 5.50052 6.27812 5.50052 9.49986V11.8232C5.50052 13.4723 4.77802 15.029 3.51047 16.1007C3.08795 16.4615 2.90042 17.0365 3.05209 17.5974C3.22879 18.2499 3.87378 18.6666 4.55051 18.6666H18.113C18.823 18.6666 19.4922 18.2065 19.6363 17.5107C19.748 16.9724 19.5563 16.4348 19.1388 16.084C17.9271 15.0683 17.2263 13.5756 17.1772 11.9991C17.1755 11.9991 17.1738 11.9993 17.1721 11.9995ZM11.3331 22C12.8423 22 14.1048 20.9241 14.3947 19.5H8.27138C8.56145 20.9241 9.82396 22 11.3331 22Z",
    fill: "#D5DAE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 6.16672C21.3333 8.46789 19.4679 10.3333 17.1666 10.3333C14.8654 10.3333 13 8.46789 13 6.16672C13 3.86554 14.8654 2 17.1666 2C19.4679 2 21.3333 3.86554 21.3333 6.16672Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.cbe9c765bff28d07f512c34af04c26b0.svg";
export { ForwardRef as ReactComponent };